import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
    const [openFAQ, setOpenFAQ] = useState<number | null>(null);

    const toggleFAQ = (index: number) => {
        setOpenFAQ(openFAQ === index ? null : index);
    };

    const faqData = [
        {
            question: "Do I need to bring the car for the appraisal, or could it be done over the phone or online?",
            answer: "While you can do your appraisal over the phone or online it is best to bring the car for a quick inspection. Although you can do the whole process online or over the phone and your appraisal stays the same as long as the conditions you provide us, matches the actual condition of the car."
        },
        {
            question: "Can you buy my car if it is financed or leased and I owe money on the car?",
            answer: "We buy all the cars if they are financed, all we need is 10 days' pay off from your financial institution who you have financed the car with . We buy most of the leased cars also as long as there is no restriction for third party purchase from manufacturers."
        },
        {
            question: "Can I sale my car if I have lost my title?",
            answer: "Yes, we will buy your car and process the duplicated title on behalf of you from DMV, but we will issue the funds once we receive the title from DMV "
        },
        {
            question: "Do I get more value for my car if I fix any needed repair on the car prior to getting the appraisal?",
            answer: "Most likely our cost of repair and reconditioning is lower than your cost, so do not worry about the repair. You get more value if you repair it but our deduction from the value of the car is less than your cost of repair."
        },
        {
            question: "What do I need to bring when I am finalizing my appraisal?",
            answer: "All you need is your title, registration, ID and all the keys to your car."
        },
        {
            question: "Do I receive my check at the end of my appointment?",
            answer: "Most of the time you will receive your check after you finish the paperwork as long as everything checks out correctly and you leave the car with us. In some cases, we will overnight your check as soon as the paperwork is complete."
        },
        {
            question: "Do I need an appointment to bring the car?",
            answer: "While we take walk in customer, we recommend you to set up an appointment for faster service."
        }
    ];

    return (
        <div className="font-sans bg-gray-50">
            {/* Hero Section */}
            <section id="home" className="hero flex items-center justify-center text-white bg-cover bg-center relative" style={{
                height: '90vh'
            }}>
                <div className="absolute inset-0 bg-cover bg-center" style={{
                    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgb(12 11 11 / 60%)), url(https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80)',
                    transform: 'scaleX(-1)'
                }}></div>
                <div className="container mx-auto px-4 text-center relative z-10">
                    <h1 className="text-4xl md:text-6xl font-bold mb-6"> Drive Your Dream Car Today</h1>
                    <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto">Premium selection of new and pre-owned vehicles at competitive prices</p>

                    <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                        <a
                            href="https://drivetodayauto.mycarsonline.com/apply-online"
                            className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-3 rounded-md font-medium transition text-center"
                        >
                            <i className="fas fa-dollar-sign mr-2"></i> Financing Options
                        </a>
                        <a
                            href="https://drivetodayauto.mycarsonline.com/inventory"
                            className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-3 rounded-md font-medium transition text-center"
                        >
                            <i className="fas fa-car mr-2"></i> Browse Inventory
                        </a>
                        <Link to="/car-appraisal" className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white px-8 py-3 rounded-md font-medium transition text-center">
                            <i className="fas fa-calculator mr-2"></i> Get Appraisal
                        </Link>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="py-8 bg-red-600 text-white">
                <div className="container mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-2xl font-bold mb-4">Why Choose Drive Today Auto?</h2>
                        <p className="max-w-1xl mx-auto opacity-90">We're committed to providing exceptional service and value to every customer</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="text-center p-6">
                            <div className="bg-white bg-opacity-20 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                                <i className="fas fa-medal text-3xl"></i>
                            </div>
                            <h3 className="text-xl font-bold mb-2">Inspection & Quality Assurance</h3>
                            <p className="opacity-90">All our pre-owned vehicles undergo a rigorous, multi-step inspection to ensure they meet our high standards
                                For saftey, performance and
                                reliability.</p>
                        </div>

                        <div className="text-center p-6">
                            <div className="bg-white bg-opacity-20 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                                <i className="fas fa-hand-holding-usd text-3xl"></i>
                            </div>
                            <h3 className="text-xl font-bold mb-2">Best Prices</h3>
                            <p className="opacity-90">We offer competitive pricing and flexible financing options for every budget.</p>
                        </div>

                        <div className="text-center p-6">
                            <div className="bg-white bg-opacity-20 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                                <i className="fas fa-headset text-3xl"></i>
                            </div>
                            <h3 className="text-xl font-bold mb-2">Support</h3>
                            <p className="opacity-90">Our customer service team is dedicated to assisting you as quickly as possible during our regular business hours.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services */}
            <section id="services" className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Services</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">Comprehensive automotive services to keep your vehicle in top condition</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 hover:border-red-500 transition">
                            <div className="bg-red-100 text-red-600 w-14 h-14 rounded-full flex items-center justify-center mb-4">
                                <i className="fas fa-car text-2xl"></i>
                            </div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2">Vehicle Sales</h3>
                            <p className="text-gray-600 mb-4">We offer a range of quality, pre-owned vehicles competitive prices. Each car is carefully inspected to ensure performance, reliability, and peace of mind for our customers.</p>
                            <div className="flex justify-center">
                                <a
                                    href="https://drivetodayauto.mycarsonline.com/inventory"
                                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                                >
                                    <i className="fas fa-car mr-2"></i> Inventory
                                </a>
                            </div>
                        </div>

                        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 hover:border-red-500 transition">
                            <div className="bg-red-100 text-red-600 w-14 h-14 rounded-full flex items-center justify-center mb-4">
                                <i className="fas fa-file-invoice-dollar text-2xl"></i>
                            </div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2">Financing</h3>
                            <p className="text-gray-600 mb-4">Flexible financing options with competitive rates from multiple lenders. we are bound to get you financed. Good Credit, Bad Credit, First Time Buyer? Our lenders work with all types of scores and situations.</p>
                            <div className="flex justify-center">
                                <a
                                    href="https://drivetodayauto.mycarsonline.com/apply-online"
                                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                                >
                                    <i className="fas fa-file-invoice-dollar mr-2"></i> Apply Now
                                </a>
                            </div>
                        </div>

                        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 hover:border-red-500 transition">
                            <div className="bg-red-100 text-red-600 w-14 h-14 rounded-full flex items-center justify-center mb-4">
                                <i className="fas fa-handshake text-2xl"></i>
                            </div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2">New Car Brokerage</h3>
                            <p className="text-gray-600 mb-4">As an independent broker, we work on your behalf to find the best deals on new vehicles— whether you're looking to lease or finance. Let us save you the time and stress of negotiating with dealerships.</p>
                            <div className="flex justify-center">
                                <a
                                    href="https://drivetodayauto.mycarsonline.com/car-finder"
                                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                                >
                                    <i className="fas fa-search mr-2"></i> Find Car
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Got Questions?</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">Find answers to the most common questions about selling your vehicle to us</p>
                    </div>

                    <div className="max-w-4xl mx-auto">
                        {faqData.map((faq, index) => (
                            <div key={index} className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
                                <button
                                    onClick={() => toggleFAQ(index)}
                                    className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
                                >
                                    <span className="font-semibold text-gray-800 text-lg">{faq.question}</span>
                                    <i className={`fas fa-chevron-${openFAQ === index ? 'up' : 'down'} text-red-600 transition-transform duration-200`}></i>
                                </button>
                                <div className={`px-6 py-4 bg-white border-t border-gray-200 transition-all duration-300 ${openFAQ === index ? 'block' : 'hidden'}`}>
                                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-8">
                        <p className="text-gray-600 mb-4">Still have questions? We're here to help!</p>
                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                            <a
                                href="tel:+17472656569"
                                className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                            >
                                <i className="fas fa-phone-alt mr-2"></i> Call Us
                            </a>
                            <a
                                href="mailto:info@drivetodayauto.us"
                                className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                            >
                                <i className="fas fa-envelope mr-2"></i> Email Us
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Contact Us</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">Have questions? Our team is ready to help you find your perfect vehicle</p>
                    </div>

                    <div className="max-w-2xl mx-auto">
                        <div className="bg-white p-8 rounded-lg shadow-md">
                            <div className="flex items-start mb-8">
                                <div className="bg-red-100 text-red-600 p-3 rounded-full mr-4">
                                    <i className="fas fa-map-marker-alt text-xl"></i>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-gray-800 mb-2">Our Location</h3>
                                    <p className="text-gray-600">18923 Ventura Blvd<br />Tarzana, CA 91356</p>
                                </div>
                            </div>

                            <div className="flex items-start mb-8">
                                <div className="bg-red-100 text-red-600 p-3 rounded-full mr-4">
                                    <i className="fas fa-clock text-xl"></i>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-gray-800 mb-2">Business Hours</h3>
                                    <p className="text-gray-600">
                                        Monday - Friday: 9:00 AM - 7:00 PM<br />
                                        Saturday: 10:00 AM - 7:00 PM<br />
                                        Sunday: Closed
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start mb-8">
                                <div className="bg-red-100 text-red-600 p-3 rounded-full mr-4">
                                    <i className="fas fa-phone-alt text-xl"></i>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-gray-800 mb-2">Contact Info</h3>
                                    <p className="text-gray-600 mb-2">
                                        <span className="font-medium">Sales:</span>{' '}
                                        <a
                                            href="tel:+17472656569"
                                            className="hover:text-red-600 transition"
                                        >
                                            (747) 265-6569
                                        </a>
                                    </p>
                                    <p className="text-red-600 font-medium">
                                        <i className="fas fa-envelope mr-2"></i>{' '}
                                        <a
                                            href="mailto:info@drivetodayauto.us"
                                            className="hover:text-red-800 transition"
                                        >
                                            info@drivetodayauto.us
                                        </a>
                                    </p>
                                </div>
                            </div>

                            <div className="text-center pt-6 border-t border-gray-200">
                                <p className="text-gray-600 mb-4">Ready to get started?</p>
                                <div className="flex flex-col sm:flex-row justify-center gap-4">
                                    <a
                                        href="tel:+17472656569"
                                        className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                                    >
                                        <i className="fas fa-phone-alt mr-2"></i> Call Now
                                    </a>
                                    <a
                                        href="https://drivetodayauto.mycarsonline.com/inventory"
                                        className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                                    >
                                        <i className="fas fa-car mr-2"></i> Browse Inventory
                                    </a>
                                    <Link
                                        to="/car-appraisal"
                                        className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium transition inline-flex items-center justify-center"
                                    >
                                        <i className="fas fa-calculator mr-2"></i> Get Appraisal
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home; 